<template>
  <validation-observer ref="textAttributeForm">
    <div>
      <div class="form-group p-0-14">
        <validation-provider
          :rules="attribute.mandatory ? 'required' : ''"
          v-slot="{ errors }"
        >
          <div class="text-attribute">
            <label class="attribute-label" :for="id">
              {{ attribute.attribute_name }}
              <a
                href="javascript:;"
                data-toggle="popover"
                data-placement="bottom"
                data-html="true"
                :data-content="popover_custom_data(attribute.extra_info)"
                v-if="removeTags(attribute.extra_info) !== ''"
              >
                <i class="fa fa-info-circle"></i>
              </a>
              <span class="cost-attribute" style="text-align: left">
                <span
                  class="unit_price"
                  v-if="
                    attribute.unit_price && parseFloat(attribute.unit_price) > 0
                  "
                >
                  +{{
                    priceText(
                      attribute.unit_price,
                      attribute.cost_type,
                      currency,
                      unit
                    )
                  }}
                </span>
                <span
                  class="attribute_additional_timeData"
                  v-if="attribute.attribute_additional_time"
                >
                  {{
                    callAdditionalTimeTextData(
                      attribute.attribute_additional_time
                    )
                  }}
                </span>
              </span>
            </label>

            <input
              :type="isNumeric() ? 'number' : 'text'"
              :name="name"
              step="0.01"
              :id="id"
              class="form-control new-inputs"
              @input="onChange"
              :value="textValue"
            />
          </div>
          <span
            class="text text-danger error-label"
            v-if="errors && errors.length"
            >{{ errors[0] }}</span
          >
        </validation-provider>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { EventBus } from "@/events/event-bus";
import attribute from "@/modules/Services/components/attributes/Attribute.vue";
import { priceText } from "@/events/sharedMethods.js";

export default {
  name: "TextAttribute",
  props: {
    attribute: {
      type: Object,
      required: true,
    },
    value: "",
    clone: 0,
    currency: {
      required: true,
    },
    unit: {
      required: true,
    },
    additionalTimeTextData: Function,
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      textValue: this.value,
    };
  },
  computed: {
    /**
     * get attribute input id
     * @returns {string}
     */

    id() {
      if (parseInt(this.clone)) {
        return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}_${this.clone}`;
      }

      return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}`;
    },
    /**
     * get attribute input name
     * @returns {string}
     */
    name() {
      if (parseInt(this.clone)) {
        return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}_${this.clone}`;
      }

      return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}`;
    },
  },
  methods: {
    triggerChange() {
      EventBus.$emit(
        "onServiceCustomFieldSelected",
        this.attribute.service_id,
        this.clone
      );
    },
    priceText,
    callAdditionalTimeTextData(val) {
      return this.additionalTimeTextData(val);
    },
    addEventListeners() {
      EventBus.$on("onServiceAttributesValidation", async (verify) => {
        let validated = await this.$refs.textAttributeForm.validate();
        if (!validated) {
          /** If there is a validation error then show the validation and open collapsed services  **/
          EventBus.$emit("onCollapseService", this.attribute);
        }
        verify(validated);
      });
    },
    isNumeric() {
      if (this.attribute.is_price_attribute) {
        return true;
      }
      return false;
    },

    onChange(event) {
      this.textValue = event.target.value;
      this.$emit("input", event.target.value);
      EventBus.$emit("onCustomFieldUpdated", {
        attribute: this.attribtue,
        value: this.textValue,
      });
    },
    removeTags(value) {
      const div = document.createElement("div");
      div.innerHTML = value;
      var DataToAdd = null;
      if (div.textContent) {
        DataToAdd = div.textContent;
      } else if (div.innerText) {
        DataToAdd = div.innerText;
      } else {
        DataToAdd = "";
      }
      if (DataToAdd) {
        return `<div class="p-all-14 font-size-13 font-weight-100   popover_custom_data "   >${DataToAdd}</div>`;
      } else {
        return DataToAdd;
      }
    },
    popover_custom_data(value) {
      return `<div class="p-all-14 font-size-13 font-weight-100   popover_custom_data "   >${value}</div>`;
    },
  },
  mounted() {
    this.addEventListeners();
    if (this.attribute.service_attribute_value) {
      this.textValue = this.attribute.service_attribute_value;
    }
  },
  watch: {
    textValue: {
      handler: function (data) {
        this.$nextTick(() => {
          this.attribute.value = this.textValue;
          this.attribute.service_attribute_value = this.textValue;
          this.triggerChange(data, this.attribute);
        });
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
